// src/utils/formatters.js (рекомендуется новый файл)

/**
 * Форматирует большие числа, сокращая тысячи до "k".
 * @param {number} num - Число для форматирования.
 * @returns {string | number} - Отформатированная строка или исходное число.
 */
export function formatNumber(num) {
  if (num >= 1000000) {
    return (num / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';
  }
  if (num >= 1000) {
    return (num / 1000).toFixed(1).replace(/\.0$/, '') + 'k';
  }
  return num;
}